'use strict';

import config from '../../../js/config';
import NotificationBar from '../../NotificationBar/NotificationBar';
import template from '../templates/_MyArrowUserNotification.hbs';
import cookies from 'js-cookie';
import cacheCookieHelper from '../../../components/CacheCookieHelper/CacheCookieHelper';

export default class MyArrowUserNotificationBar extends NotificationBar {
  initialize() {
    this.template = template;
    super.initialize();
  }

  dismiss(e) {
    cookies.set(config.cookies.myArrowNotification, new Date().toUTCString(), { path: '/', domain: '.arrow.com', expires: config.cookies.myArrowNotificationCookieExpiration });
    if (cacheCookieHelper) {
      cacheCookieHelper.setCacheCookie();
    }
    super.dismiss(e);
  }

  static shouldDisplay() {
    let myArrowUserNotification = cookies.get(config.cookies.myArrowNotification);
    return (!myArrowUserNotification);
  }
}



// WEBPACK FOOTER //
// ./assets/components/Header/js/MyArrowUserNotificationView.js